import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import AuthGateShell from "./shells/AuthGateShell";

export default function AdminRoute({ children }) {
  const { user, authReady } = useContext(AuthContext);
  const location = useLocation();

  if (!authReady) {
    return <AuthGateShell />;
  }

  if (!user) {
    // English: Preserve the exact page for a clean post-login return.
    const returnTo = `${location.pathname || "/"}${location.search || ""}${location.hash || ""}`;

    return (
      <Navigate
        to="/login"
        replace
        state={{ returnTo }}
      />
    );
  }

  // English: Allow only admin/moderator.
  const allowed = new Set(["admin", "moderator"]);
  if (!allowed.has(user.role)) return <Navigate to="/" replace />;

  return children;
}